<router-outlet />

<plugins-startup-spinner />
